module.exports = __webpack_public_path__ + "img/truck.c61065b6.svg";